const CustomLinkTest = ({ url, meta }) => {
  return (
    <div className="bg-white cursor-pointer hover:shadow-xl rounded p-3 shadow mb-4 flex items-center">
      {meta.img && (
        <div className="mr-6">
          <img src={meta.img} alt="" className="h-20 w-36 rounded shadow" />
        </div>
      )}
      <div className="">
        <div className="font-bold text-lg">{meta.title}</div>
        <div className="font-medium  text-sm">{meta.desc}</div>
        <div className="font-medium  text-sm text-blue-400 mt-1">{url}</div>
      </div>
    </div>
  )
}

export default CustomLinkTest
